import { Col, PageHeader } from 'antd';
import { useCulturesSlice } from 'app/containers/Cultures/slice';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { LEFT_COL_WIDTH } from 'utils/constants';
import useDebounce from 'utils/hooks/useDebounce';
import TaskCategoriesCard from '../../parts/TaskCategoriesCard/TaskCategoriesCard';
import TaskCategoryResourcesCard from '../../parts/TaskCategoryResourcesCard/TaskCategoryResourcesCard';
import TaskUsedResourceDistributionCard from '../../parts/TaskUsedResourceDistributionCard/TaskUsedResourceDistributionCard';
import { useResourceSlice } from '../../slice';
import { IWarehouseFilters, WarehouseFiltersEnum } from '../../slice/types';

import * as S from './ResourceAllocation.styles';

interface IReactRouterParams {
  taskCategoryId?: string;
  usedResourceId?: string;
}
interface IProps extends RouteComponentProps<IReactRouterParams> {}

const ResourceAllocation: FC<IProps> = ({
  match: {
    params: { taskCategoryId, usedResourceId },
  },
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { actions } = useResourceSlice();
  const { actions: cultureActions } = useCulturesSlice();

  const [filters, setFilters] = useState<IWarehouseFilters>({
    startDate: null,
    endDate: null,
    search: '',
    cultureId: null,
  });

  const debouncedFilters: IWarehouseFilters = useDebounce<IWarehouseFilters>(
    filters,
    500,
  );

  const setFilterValue = (
    name: WarehouseFiltersEnum,
    value: string | number | null,
  ) => {
    setFilters(prevFilters => ({ ...prevFilters, [name]: value }));
  };

  useEffect(() => {
    if (taskCategoryId) {
      dispatch(actions.setSelectedTaskCategoryId(Number(taskCategoryId)));
    }
    if (usedResourceId) {
      dispatch(actions.setSelectedUsedResourceId(Number(usedResourceId)));
    }
  }, [taskCategoryId, usedResourceId, dispatch, actions]);

  useEffect(() => {
    dispatch(cultureActions.getCultures());
  }, [dispatch, cultureActions]);

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Resource.ResourceAllocation.Title', 'Resource allocation')}
      />
      <S.Container wrap={false}>
        <Col flex={LEFT_COL_WIDTH}>
          <TaskCategoriesCard />
        </Col>
        <Col flex={LEFT_COL_WIDTH} style={{ marginLeft: 12 }}>
          <TaskCategoryResourcesCard
            filters={debouncedFilters}
            setFilterValue={setFilterValue}
          />
        </Col>
        <Col flex={1} style={{ marginLeft: 12 }}>
          <TaskUsedResourceDistributionCard filters={debouncedFilters} />
        </Col>
      </S.Container>
    </>
  );
};

export default ResourceAllocation;
